import { render, staticRenderFns } from "./CoachingCourses.vue?vue&type=template&id=04520b04&"
import script from "./CoachingCourses.vue?vue&type=script&lang=js&"
export * from "./CoachingCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports